module.exports = __webpack_public_path__ + "img/24.6cb62268.png";